import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeSwitcherProps {
  className?: string;
  showLabel?: boolean;
}

export function ThemeSwitcher({ className = '', showLabel = true }: ThemeSwitcherProps) {
  const { themeName, toggleTheme } = useTheme();
  const isCommand = themeName === 'command';

  return (
    <button
      onClick={toggleTheme}
      className={`
        inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium
        bg-surface-700 hover:bg-surface-600
        border border-surface-500 rounded-lg
        text-text-secondary hover:text-text-primary
        transition-all duration-200
        ${className}
      `}
      title={`Switch to ${isCommand ? 'Modern' : 'Command'} theme`}
    >
      {isCommand ? (
        <Sun size={16} className="text-warning-400" />
      ) : (
        <Moon size={16} className="text-primary-400" />
      )}
      {showLabel && (
        <span>{isCommand ? 'Modern' : 'Command'}</span>
      )}
    </button>
  );
}
